import styled from '@olxeu-a2b/ui/src/theme/styled';
import mq from '../../../../../commons/styles/mediaQueries';

import DeliveryTruck from '../images/delivery.svg';

const Container = styled.div`
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.primary};
  background-color: ${({ theme }) => theme.colors.bgSecondary};
  display: flex;
  flex-direction: column;
  height: calc(100vh - 170px);
  justify-content: center;

  ${mq.desktop} {
    height: fit-content;
  }
`;

const WaterMark = styled.div`
  display: flex;
  flex-flow: column;
  margin: 32px 0 16px;
`;

const DeliveryIcon = styled(DeliveryTruck)`
  align-self: center;
  height: 180px;
  width: 180px;
  ${mq.desktop} {
    width: 280px;
    height: 280px;
  }
`;

const DetailsLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.linkPrimary};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;

const Tip = styled.p<{ isActionBtn: boolean }>`
  color: ${({ theme }) => theme.colors.secondary};
  text-align: center;
  font-size: ${({ theme }) => theme.sizes.m};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  margin: 0;
  line-height: ${({ theme }) => theme.lineHeights[18]};
  padding: 0 46px 14px;
  flex-grow: ${props => (props.isActionBtn ? '1' : '0')};

  ${mq.desktop} {
    max-width: 480px;
    flex-grow: 0;
  }
`;

export default {
  Container,
  WaterMark,
  DeliveryIcon,
  DetailsLink,
  Tip,
};
